//-- Copyright (c) 2021 TMT Insights Group, LLC
import axios from '@/_utils/axios';
import { setDraftState } from '@/redux/slices/orderPlacementSlice';
import { useHistory } from 'react-router-dom';
import PolarisIcon from '../_common/PolarisIcon';
import { OrderDetail } from '@/redux/slices/slice_types';
import styled from '@emotion/styled';
import { selectCanWriteOrders } from '@/redux/selectors/authSelectors';
import { useState } from 'react';
import BulkSearchModal from '../OrderPlacement/OPStep2VersionSelection/BulkSearch/BulkSearchModal/BulkSearchModal';
import { IconButton, Tooltip } from '@mui/material';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import { convertOrderRequestsToDraftState } from '@/_utils/orderUtils';
import { selectAllProfiles } from '../../redux/selectors/profileSelectors';

type ResumeDraftProps = {
  order: OrderDetail;
};

const ResumeDraft = ({ order }: ResumeDraftProps) => {
  const dispatch = useAppDispatch();
  const history = useHistory();
  const canWriteOrders = useAppSelector(selectCanWriteOrders);
  const allProfiles = useAppSelector(selectAllProfiles);
  const hasDraft = order.status === 'draft';
  const isBulk = order.order_type === 'bulk';
  const [isOpen, setIsOpen] = useState(false);

  const handleResumeDraft = (e: React.MouseEvent) => {
    e.stopPropagation();
    axios.get(`/core/orders/${order.id}/`).then((res) => {
      const draftState =
        res.data.data?.order_requests && Object.keys(res.data.data.order_requests).length > 0
          ? {
              ...convertOrderRequestsToDraftState(res.data.data, allProfiles),
              draftId: order.id
            }
          : { ...res.data.data.draft_state, draftId: order.id };

      dispatch(setDraftState(draftState));
      history.push('/orders-v2/new');
    });
  };

  const handleViewBulk = (e: React.MouseEvent) => {
    e.stopPropagation();
    setIsOpen(true);
  };

  if (!isBulk && (!hasDraft || !canWriteOrders)) return;
  return (
    <Wrapper>
      <Tooltip title={isBulk ? 'View Bulk Order' : 'Resume Draft'}>
        <IconButton onClick={isBulk ? handleViewBulk : handleResumeDraft}>
          <PolarisIcon icon={isBulk ? 'bulk' : 'draft'} height={18} width={18} style={{ opacity: 0.5 }} />
        </IconButton>
      </Tooltip>
      <BulkSearchModal
        open={isOpen}
        onClose={() => {
          setIsOpen(false);
        }}
        id={order.id}
      />
    </Wrapper>
  );
};

export default ResumeDraft;

const Wrapper = styled.div`
  display: flex;
  height: 100%;
  width: 100%;
  justify-content: center;
  align-items: center;
`;
